// console.log('hello products!!');
import $ from 'jquery';

// 手風琴
const accordionToggler = document.querySelector( '.accordion__toggler' );
const secondAccordionToggler = document.querySelectorAll( '.accordion__subcategory .accordion__toggler' );
const subcategoryAccordion = document.querySelectorAll( '.accordion__subcategory' );
const childCategory = document.querySelectorAll( '.childCategory' );
const detailCategory = document.querySelectorAll( '.accordion__detailcategory a' );
const accordionBody = document.querySelector( '.accordion__body' );

let targetPage = null;
let targetCategory = null;

// 抓取 local storage 的資料
const targetCategoryLocal = JSON.parse( localStorage.getItem( 'targetCategory' ) );
// 抓取 application 的第三個分類的 DOM
const accordionChildList = document.querySelectorAll( '[data-hometarget]' );

accordionToggler.addEventListener( 'click', function() {
	const accordionVertical = accordionToggler.querySelector( '.accordion__icon-vertical' );
	accordionVertical.classList.toggle( 'active' );
	if ( accordionBody.classList.contains( 'active' ) ) {
		accordionBody.classList.remove( 'active' );
		childCategory.forEach( ( child ) => {
			child.classList.remove( 'active' );
		} );
		secondAccordionToggler.forEach( ( toggler ) => {
			const subAccordionVertical = toggler.querySelector( '.accordion__icon-vertical' );
			subAccordionVertical.classList.remove( 'active' );
		} );
	} else if ( ! accordionBody.classList.contains( 'active' ) ) {
		accordionBody.classList.add( 'active' );
	}
} );

// 第二層手風琴開關
subcategoryAccordion.forEach( ( accordion ) => {
	const subAccordionToggler = accordion.querySelector( '.accordion__toggler' );
	const accordionIconVertical = accordion.querySelector( '.accordion__icon-vertical' );
	const childCategory = accordion.querySelector( '.accordion__childcategory' ); // eslint-disable-line
	subAccordionToggler.addEventListener( 'click', () => {
		accordionIconVertical.classList.toggle( 'active' );
		subcategoryAccordion.forEach( ( subAccordion ) => {
			subAccordion.style.opacity = '1';
		} );

		if ( childCategory.classList.contains( 'active' ) ) {
			childCategory.classList.remove( 'active' );
		} else if ( ! childCategory.classList.contains( 'active' ) ) {
			childCategory.classList.add( 'active' );
		}
	}	);
}	);

// 第三層手風琴開關
childCategory.forEach( ( accordion ) => {
	// 抓第三層的分類手風琴
	const accordionToggler = accordion.querySelectorAll( '.accordion__toggler' ); // eslint-disable-line
	const detailCategory = accordion.nextSibling.nextSibling; // eslint-disable-line

	accordionToggler.forEach( ( toggler ) => {
		const accordionIconVertical = toggler.querySelector( '.accordion__icon-vertical' );
		toggler.addEventListener( 'click', () => {
			if ( accordionIconVertical.classList.contains( 'active' ) ) {
				accordionIconVertical.classList.remove( 'active' );
			} else if ( ! accordionIconVertical.classList.contains( 'active' ) ) {
				accordionIconVertical.classList.add( 'active' );
			}

			if ( detailCategory.classList.contains( 'active' ) ) {
				detailCategory.classList.remove( 'active' );
			} else if ( ! detailCategory.classList.contains( 'active' ) ) {
				detailCategory.classList.add( 'active' );
			}
		} );
	} );
} );

let postsData = [];
let totalPage = null;
let tempPostsData = [];
// products_categories
// ajax
function getPostsData( { page = 1, category = 'cat-products-categories' } = {} ) {
	const data = {
		action: 'productsList',
		category,
		page,
	};

	$.ajax ( { // eslint-disable-line
		type: 'POST',
		url:ajax_link.ajax_url, // eslint-disable-line
		data,
		success: ( res ) => {
			tempPostsData = res.postDatas;
			totalPage = res.totalPage;
			// postsData = res.postDatas;
			postsData = [];
			const seriesArr = [];
			const otherArr = [];
			tempPostsData.forEach( ( value ) => {
				if ( value.title.includes( 'SERIES' ) ) {
					seriesArr.push( value );
				} else {
					otherArr.push( value );
				}
			} );
			// seriesArr.forEach( ( value, index ) => {
			// 	const firstParentheses = value.title.indexOf( '(' );
			// 	const lastParentheses = value.title.indexOf( ')' ) + 1;
			// 	const num = value.title.slice( firstParentheses, lastParentheses );
			// 	const numNoSer = value.title.slice( 0,firstParentheses );
			// 	seriesArr[ index ].serices = num;
			// 	seriesArr[ index ].nameOutSer = numNoSer;
			// } );
			// function compareStrings( str1, str2 ) {
			// 	const num1 = str1.serices;
			// 	const num2 = str2.serices;
			// 	return num1.localeCompare( num2 );
			// }
			// seriesArr.sort( compareStrings );
			postsData = [ ...seriesArr, ...otherArr ];
			renderPagination( page, category );
			renderProductsList();
		} } );
}

// 抓取產品列表動元素
const productsList = document.querySelector( '.productsList' );

// 渲染產品列表
function renderProductsList() {
	let productsStr = '';
	postsData.forEach( ( item ) => {
		productsStr += `
      <li class="product-item col-md-4 mb-10">
        <a href="${ item.link }" class="product-item__link">
          <img src="${ item.thumbnail }" class="mb-6 img-fluid">
          <h5>${ item.title }</h5>
        </a>
      </li>
    `;
	}	);
	productsList.innerHTML = productsStr;

	// const productItemLink = document.querySelectorAll( '.product-item__link' );
}

// 渲染 pagination
// 抓取動元素
const pagination = document.querySelector( '.pagination' );

// pagination 渲染
function renderPagination( currentPage = 1, category ) {
	let str = '';

	for ( let page = 1; page <= totalPage; page++ ) {
		if ( currentPage === page ) {
			str += `
      <li class="pagination__item pagination__item">
        <a href="#" class="pagination__link pagination__link--active" data-page="${ page }"
        data-category="${ category }">${ page }</a>
      </li>
      `;
		} else {
			str += `
      <li class="pagination__item pagination__item">
        <a href="#" class="pagination__link" data-page="${ page }"
        data-category="${ category }">${ page }</a>
      </li>
      `;
		}
	}
	pagination.innerHTML = str;
	const pageList = document.querySelectorAll( '.pagination .pagination__item' );

	// 創造省略符號
	const beforeIgnoreIcon = document.createElement( 'p' );
	beforeIgnoreIcon.innerHTML = '...';
	const afterIgnoreIcon = document.createElement( 'p' );
	afterIgnoreIcon.innerHTML = '...';

	if ( totalPage > 7 ) {
		if ( currentPage <= 4 ) {
			pageList.forEach( ( item, index ) => {
				if ( index > 4 && index < totalPage - 1 ) {
					item.style.display = 'none';
				}
			}	);
			pageList[ totalPage - 1 ].insertAdjacentElement( 'beforebegin', beforeIgnoreIcon );
		} else if ( currentPage > 4 && currentPage < totalPage - 4 ) {
			pageList.forEach( ( item, index ) => {
				// 這個條件是去把當前頁面的前後兩頁抓出來
				if ( index < currentPage - 3 || index > currentPage + 1 ) {
				// 除了第一頁跟最後一頁不反應
					if ( ! ( index === 0 || index === totalPage - 1 ) ) {
						item.style.display = 'none';
					}
				}
			}	);
			pageList[ totalPage - 1 ].insertAdjacentElement( 'beforebegin', beforeIgnoreIcon );
			pageList[ 0 ].insertAdjacentElement( 'afterend', afterIgnoreIcon );
		} else if ( currentPage === totalPage - 4 || currentPage === totalPage - 3 || currentPage === totalPage - 2 || currentPage === totalPage - 1 || currentPage === totalPage ) {
			pageList.forEach( ( item, index ) => {
				if ( index < totalPage - 5 ) {
					if ( ! ( index === 0 ) ) {
						item.style.display = 'none';
					}
				}
			}	);
			pageList[ 0 ].insertAdjacentElement( 'afterend', afterIgnoreIcon );
		}
	}

	eventListenerPagination();
}

// pagination 監聽器
function eventListenerPagination() {
	const paginationLinkList = document.querySelectorAll( '.pagination__link' );
	paginationLinkList.forEach( ( item ) => {
		item.addEventListener( 'click', ( e ) => {
			e.preventDefault();
			targetPage = parseInt( e.target.dataset.page );
			localStorage.setItem( 'targetPage', targetPage );
			targetCategory = e.target.dataset.category;
			getPostsData( { page: targetPage, category: targetCategory } );
		} );
	} );
}

// 換分類
// 抓取分類動元素
const accordionChildcategoryLink = document.querySelectorAll( '.accordion__childcategory__link' );
const accordionSubcategoryHeader = document.querySelectorAll( '.accordion__subcategory-header a' );

accordionChildcategoryLink.forEach( ( item, index, array ) => {
	item.addEventListener( 'click', ( e ) => {
		e.preventDefault();

		array.forEach( ( value ) => {
			value.classList.remove( 'active' );
		} );
		accordionSubcategoryHeader.forEach( ( object ) => {
			object.classList.remove( 'active' );
		} );
		if ( item.classList.contains( 'active' ) ) {
			item.classList.remove( 'active' );
		} else {
			item.classList.add( 'active' );
		}

		const category = item.dataset.category;

		const primaryCategory = item.dataset.primarycategory;
		const secondaryCategory = item.dataset.secondarycategory;
		const thirdCategory = item.dataset.thirdcategory;
		const fourthCategory = item.dataset.fourthcategory;

		const categoryObj = {
			primaryCategory,
			secondaryCategory,
			thirdCategory,
			fourthCategory,
			targetPage,
		};
		localStorage.setItem( 'targetPage', 1 );
		localStorage.setItem( 'categoryObj', JSON.stringify( categoryObj ) );
		getPostsData( { category } );
	} );
} );

const accordionDetailcategoryLink = document.querySelectorAll( '.accordion__detailcategory__link' );

accordionDetailcategoryLink.forEach( ( item, index, array ) => {
	item.addEventListener( 'click', ( e ) => {
		e.preventDefault();
		array.forEach( ( value ) => {
			value.classList.remove( 'active' );
		} );

		if ( item.classList.contains( 'active' ) ) {
			item.classList.remove( 'active' );
		} else {
			item.classList.add( 'active' );
		}

		const category = item.dataset.category;

		const primaryCategory = item.dataset.primarycategory;
		const secondaryCategory = item.dataset.secondarycategory;
		const thirdCategory = item.dataset.thirdcategory;
		const fourthCategory = item.dataset.fourthcategory;

		const categoryObj = {
			primaryCategory,
			secondaryCategory,
			thirdCategory,
			fourthCategory,
			targetPage,
		};

		localStorage.setItem( 'targetPage', 1 );
		localStorage.setItem( 'categoryObj', JSON.stringify( categoryObj ) );
		getPostsData( { category } );
	} );
} );

accordionSubcategoryHeader.forEach( ( item, index, array ) => {
	item.addEventListener( 'click', ( e ) => {
		array.forEach( ( value ) => {
			value.classList.remove( 'active' );
		} );
		accordionChildcategoryLink.forEach( ( object ) => {
			object.classList.remove( 'active' );
		} );
		e.preventDefault();
		if ( item.classList.contains( 'active' ) ) {
			item.classList.remove( 'active' );
		} else {
			item.classList.add( 'active' );
		}
		const category = item.dataset.category;

		const primaryCategory = item.dataset.primarycategory;
		const secondaryCategory = item.dataset.secondarycategory;
		const thirdCategory = item.dataset.thirdcategory;
		const fourthCategory = item.dataset.fourthcategory;

		const categoryObj = {
			primaryCategory,
			secondaryCategory,
			thirdCategory,
			fourthCategory,
			targetPage,
		};
		localStorage.setItem( 'targetPage', 1 );
		localStorage.setItem( 'categoryObj', JSON.stringify( categoryObj ) );
		getPostsData( { category } );
	} );
} );

// 母分類連結
const catProductsCategories = document.querySelector( 'a[data-category="cat-products-categories"]' );
catProductsCategories.addEventListener( 'click', ( e ) => {
	e.preventDefault();
	const category = e.target.dataset.category;
	localStorage.setItem( 'categoryObj', JSON.stringify( '' ) );
	getPostsData( { category } );
} );

const applicationCategories = document.querySelector( 'a[data-category="application"]' );
applicationCategories.addEventListener( 'click', ( e ) => {
	e.preventDefault();
	const category = e.target.dataset.category;
	localStorage.setItem( 'categoryObj', JSON.stringify( '' ) );
	getPostsData( { category } );
} );

// 網頁初始化
function init() {
	// 取得網頁語言資料
	let lang = document.querySelector( 'main' ).dataset.lang;
	if ( lang !== 'en' ) {
		lang = `cat-products-categories-${ lang }`;
	} else if ( lang === 'en' ) {
		lang = `cat-products-categories`;
	}
	// 如果有資料的話，要讓手風琴打開
	let hasPrePage = false;
	const displayCategory = JSON.parse( localStorage.getItem( 'categoryObj' ) );
	const displayPage = parseInt( localStorage.getItem( 'targetPage' ) );
	let isPreProduct = JSON.parse( localStorage.getItem( 'isPreProduct' ) );
	if ( window.performance && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD ) {
		hasPrePage = true;
	}
	// 從首頁回來的話
	if ( targetCategoryLocal ) {
		// 判斷是哪一個分類
		accordionChildList.forEach( ( item ) => {
			const homeTarget = item.dataset.hometarget;
			if ( targetCategoryLocal === homeTarget ) {
				const preDom = item.previousSibling.previousSibling;
				const preDomIcon = preDom.querySelector( '.accordion__icon-vertical' );
				const subDetailCategory = item.querySelectorAll( '.accordion__detailcategory' );
				const homeAccordionVerticalList = document.querySelectorAll( `[data-hometarget="${ targetCategoryLocal }"] .accordion__icon-vertical` );
				subDetailCategory.forEach( ( obj ) => {
					obj.classList.add( 'active' );
				} );
				homeAccordionVerticalList.forEach( ( icon ) => {
					icon.classList.add( 'active' );
				} );
				item.classList.add( 'active' );
				preDomIcon.classList.add( 'active' );
				getPostsData( { category: homeTarget } );
			} else {
				const parentDom = item.parentNode;
				parentDom.style.opacity = 0.3;
			}
		} );
	} else if ( hasPrePage ) {
		if ( window.performance && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD ) {
			// 從這裡開始打開手風琴
			// 如果娶回來的是 cat-products-categories 就打開第一個手風琴
			if ( displayCategory.primaryCategory === 'cat-products-categories' ) {
				accordionBody.classList.add( 'active' );
				// 做第二個層手風琴的判斷，利用迴圈判斷傳回來的資料是哪一個分類
				accordionSubcategoryHeader.forEach( ( item ) => {
					if ( item.dataset.secondarycategory === displayCategory.secondaryCategory ) {
						if ( ! displayCategory.thirdCategory ) {
							item.classList.add( 'active' );
						}
					}
				} );
				// 打開第三層手風琴並給與連結 active
				if ( displayCategory.thirdCategory ) {
					accordionChildcategoryLink.forEach( ( item ) => {
						if ( item.dataset.thirdcategory === displayCategory.thirdCategory ) {
							const parentAccordionNode = item.parentNode;
							parentAccordionNode.classList.add( 'active' );
							item.classList.add( 'active' );
						}
					} );
				}
				getPostsData( { page: displayPage, category: displayCategory.thirdCategory } );
			} else if ( displayCategory.primaryCategory === 'application' ) {
				accordionSubcategoryHeader.forEach( ( item ) => {
					if ( item.dataset.secondarycategory === displayCategory.secondaryCategory ) {
						if ( ! displayCategory.thirdCategory ) {
							item.classList.add( 'active' );
						}
					}
				} );
				if ( displayCategory.thirdCategory ) {
					if ( ! displayCategory.fourthCategory ) {
						accordionChildcategoryLink.forEach( ( item ) => {
							if ( item.dataset.thirdcategory === displayCategory.thirdCategory && item.dataset.secondarycategory === displayCategory.secondaryCategory ) {
								const parentAccordionNode = item.parentNode.parentNode;
								parentAccordionNode.classList.add( 'active' );
								item.classList.add( 'active' );
							}
						} );
					}
				}

				// 第四層手風琴
				if ( displayCategory.fourthCategory ) {
					detailCategory.forEach( ( item ) => {
						if ( item.dataset.fourthcategory === displayCategory.fourthCategory && item.dataset.secondarycategory === displayCategory.secondaryCategory ) {
							item.classList.add( 'active' );
							const parentAccordionNode = item.parentNode;
							const motehrParentAccordionNode = item.parentNode.parentNode;
							parentAccordionNode.classList.add( 'active' );
							motehrParentAccordionNode.classList.add( 'active' );
						}
					} );
				}
				getPostsData( { page: displayPage, category: displayCategory.fourthCategory } );
			} else {
				getPostsData( { page: displayPage } );
				localStorage.setItem( 'targetPage', 1 );
			}
		} else {
			localStorage.setItem( 'isPreProduct', JSON.stringify( false ) );
			isPreProduct = JSON.parse( localStorage.getItem( 'isPreProduct' ) ); // eslint-disable-line
			localStorage.setItem( 'categoryObj', JSON.stringify( '' ) );
		}
	} else {
		localStorage.setItem( 'targetPage', 1 );
		getPostsData( { category: lang } );
	}
}

init();

